import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import BrandWiseCommisionList from './BrandWise/BrandWiseCommisionList'
import CategoryWiseCommisionList from './CategoryWise/CategoryWiseCommisionList'
import SellerWiseCommissionList from './SellerWise/SellerWiseCommissionList'
import { useSelector } from 'react-redux'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import NotFound from '../../NotFound/NotFound'

function CommissionChargesTabbing() {
  const [activeToggle, setActiveToggle] = useState('CategoryWise')

  const { pageAccess } = useSelector((state) => state.user)

  const handleTabClick = (e, tabName) => {
    e.preventDefault()
    setActiveToggle(tabName)
  }

  return checkPageAccess(
    pageAccess,
    allPages?.manageCommission,
    allCrudNames?.read
  ) ? (
    <>
      <div className='card overflow-hidden'>
        <div className='card-body p-0'>
          <div className='nav-tabs-horizontal nav nav-tabs'>
            <Link
              onClick={(e) => handleTabClick(e, 'CategoryWise')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'CategoryWise' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Category wise
                <hr />
              </span>
            </Link>
            <Link
              onClick={(e) => handleTabClick(e, 'SellerWise')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'SellerWise' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Seller wise
                <hr />
              </span>
            </Link>
            <Link
              onClick={(e) => handleTabClick(e, 'BrandWise')}
              data-toggle='tab'
              className={`nav-link fw-semibold ${
                activeToggle === 'BrandWise' ? 'active show' : ''
              }`}
            >
              <span className='nav-span'>
                Brand wise
                <hr />
              </span>
            </Link>
          </div>

          <div className='tab-content p-3'>
            <div
              id='CategoryWise'
              className={`tab-pane fade ${
                activeToggle === 'CategoryWise' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'CategoryWise' && <CategoryWiseCommisionList />}
            </div>
            <div
              id='BrandWise'
              className={`tab-pane fade ${
                activeToggle === 'BrandWise' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'BrandWise' && <BrandWiseCommisionList />}
            </div>
            <div
              id='SellerWise'
              className={`tab-pane fade ${
                activeToggle === 'SellerWise' ? 'active show' : ''
              }`}
            >
              {activeToggle === 'SellerWise' && <SellerWiseCommissionList />}
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <NotFound />
  )
}

export default CommissionChargesTabbing
